// Tax Registration Model
// Frontend display types (uppercase)
export const TAX_TYPES = ["Other", "VAT", "BTW"];

// Backend types (lowercase) - matching DB enum
export const TAX_TYPES_DB = ["other", "vat", "btw"];

// Map frontend type to backend type
export function mapTypeToDB(type) {
  const mapping = {
    Other: "other",
    VAT: "vat",
    BTW: "btw",
  };
  return mapping[type] || type.toLowerCase();
}

// Map backend type to frontend type
export function mapTypeFromDB(type) {
  const mapping = {
    other: "Other",
    vat: "VAT",
    btw: "BTW",
  };
  return mapping[type] || type.toUpperCase();
}

export function createTaxRegistration(type = "") {
  return {
    id: crypto.randomUUID(),
    type, // Frontend uses uppercase (Other, VAT, BTW)
    value: "", // Frontend uses "value", backend uses "number"
    documents: [],
  };
}
